module.exports = __webpack_public_path__ + "img/banner1.bedce539.png";